var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.order ? _c('console-content', {
    attrs: {
      "max-width": "1280"
    }
  }, [_c('v-row', {
    staticClass: "mt-3 mt-md-8 px-1",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "py-0 headline text-start",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("구매 상세정보")]), _c('v-spacer')], 1), _c('v-card', {
    staticClass: "mx-1 mt-4"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.mdiMinusThick))]), _vm._v("기본정보 "), _c('v-spacer'), _c('span', {
    staticClass: "caption grey--text"
  }, [_vm._v("주문번호")]), _c('v-divider', {
    staticClass: "mx-2 my-1",
    attrs: {
      "vertical": ""
    }
  }), _c('span', {
    staticClass: "body-2"
  }, [_vm._v(_vm._s(_vm.order.orderNo))])], 1), _c('v-divider'), _c('v-data-table', {
    staticClass: "mx-1",
    attrs: {
      "items": [_vm.order],
      "headers": _vm.ordersHeaders,
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.giftcard",
      fn: function (_ref) {
        var item = _ref.item;
        return [item.giftcard ? _c('v-row', {
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "md": "auto"
          }
        }, [item.giftcard.thumb ? _c('v-img', {
          attrs: {
            "src": item.giftcard.thumb,
            "max-width": "96",
            "max-height": "96"
          }
        }) : _c('v-responsive', {
          attrs: {
            "width": "96",
            "height": "96"
          }
        }, [_c('v-row', {
          staticClass: "fill-height ma-0 grey lighten-3",
          attrs: {
            "align": "center",
            "justify": "center"
          }
        }, [_c('v-icon', [_vm._v("mdi-image")])], 1)], 1)], 1), _c('v-col', [_c('div', {
          staticClass: "text-start"
        }, [_vm._v("[" + _vm._s(item.platform) + "]")]), _c('div', {
          staticClass: "text-start"
        }, [_vm._v(_vm._s(item.giftcard.name))])])], 1) : _vm._e()];
      }
    }, {
      key: "item.sender",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('div', [_vm._v(_vm._s(item.sender.name) + " [" + _vm._s(item.sender.id) + "]")]), _c('div', [_vm._v(_vm._s(item.sender.phone.phoneNumberFormat()))]), _c('div', [_vm._v(_vm._s(item.sender.email))])];
      }
    }, {
      key: "item.faceamt",
      fn: function (_ref3) {
        var _item$faceamt, _item$faceamt$format;
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$faceamt = item.faceamt) === null || _item$faceamt === void 0 ? void 0 : (_item$faceamt$format = _item$faceamt.format) === null || _item$faceamt$format === void 0 ? void 0 : _item$faceamt$format.call(_item$faceamt)) + " ")];
      }
    }, {
      key: "item.quantity",
      fn: function (_ref4) {
        var _item$quantity, _item$quantity$format;
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$quantity = item.quantity) === null || _item$quantity === void 0 ? void 0 : (_item$quantity$format = _item$quantity.format) === null || _item$quantity$format === void 0 ? void 0 : _item$quantity$format.call(_item$quantity)) + " ")];
      }
    }, {
      key: "item.salesAmount",
      fn: function (_ref5) {
        var _item$salesAmount, _item$salesAmount$for;
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$salesAmount = item.salesAmount) === null || _item$salesAmount === void 0 ? void 0 : (_item$salesAmount$for = _item$salesAmount.format) === null || _item$salesAmount$for === void 0 ? void 0 : _item$salesAmount$for.call(_item$salesAmount)) + " ")];
      }
    }, {
      key: "item.mode",
      fn: function (_ref6) {
        var item = _ref6.item;
        return [item.mode == 'mobile' ? _c('span', [_vm._v("모바일")]) : _vm._e(), item.mode == 'paper' ? _c('span', [_vm._v("지류")]) : _vm._e()];
      }
    }, {
      key: "item.orderedAt",
      fn: function (_ref7) {
        var item = _ref7.item;
        return [_vm._v(" " + _vm._s(_vm.$dayjs(item.orderedAt).format("YYYY-MM-DD HH:mm:ss")) + " ")];
      }
    }, {
      key: "item.status",
      fn: function (_ref8) {
        var item = _ref8.item;
        return [_c('v-select', {
          attrs: {
            "disabled": !_vm.$hasScope(['root', 'admin']),
            "items": _vm.statuses,
            "hide-details": "",
            "dense": ""
          },
          model: {
            value: item.status,
            callback: function ($$v) {
              _vm.$set(item, "status", $$v);
            },
            expression: "item.status"
          }
        })];
      }
    }], null, false, 3486998203)
  })], 1), _c('v-card', {
    staticClass: "mt-4",
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin'])
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.mdiMinusThick))]), _vm._v("구매자 정보")], 1), _c('v-card-text', [_c('v-row', [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.order.sender.name,
      "label": "이름",
      "placeholder": " ",
      "hide-details": "",
      "readonly": ""
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.order.sender.id,
      "label": "아이디",
      "placeholder": " ",
      "hide-details": "",
      "readonly": ""
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.order.sender.phone.phoneNumberFormat(),
      "label": "연락처",
      "placeholder": " ",
      "hide-details": "",
      "readonly": ""
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.order.sender.email,
      "label": "이메일",
      "placeholder": " ",
      "hide-details": "",
      "readonly": ""
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.order.shippingAddress.postcode,
      "label": "우편번호",
      "placeholder": " ",
      "hide-details": "",
      "readonly": ""
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.order.shippingAddress.address1,
      "label": "주소",
      "placeholder": " ",
      "hide-details": "",
      "readonly": ""
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.order.shippingAddress.address2,
      "label": "상세주소",
      "placeholder": " ",
      "hide-details": "",
      "readonly": ""
    }
  })], 1)], 1)], 1)], 1), _c('v-card', {
    staticClass: "mt-4",
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin'])
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.mdiMinusThick))]), _vm._v("받는사람 정보")], 1), _c('v-card-text', [_c('v-row', [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.order.receiver.name,
      "label": "이름",
      "placeholder": " ",
      "hide-details": "",
      "readonly": ""
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.order.receiver.phone.phoneNumberFormat(),
      "label": "연락처",
      "placeholder": " ",
      "hide-details": "",
      "readonly": ""
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.order.receiver.email,
      "label": "이메일",
      "placeholder": " ",
      "hide-details": "",
      "readonly": ""
    }
  })], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "mt-6 px-1"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "auto"
    }
  }), _c('v-spacer'), _vm.order.platform == 'soil' ? _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "yellow--text px-2 ml-1",
    attrs: {
      "color": "white"
    },
    on: {
      "click": _vm.zipDownload
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v(_vm._s(_vm.mdiBarrel))]), _vm._v("Soil다운로드 ")], 1)], 1) : _vm._e(), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "green--text px-2 ml-1",
    attrs: {
      "color": "white"
    },
    on: {
      "click": _vm.excel
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v(_vm._s(_vm.mdiMicrosoftExcel))]), _vm._v("엑셀다운로드 ")], 1)], 1)], 1), _vm.order.mode == 'mobile' ? _c('v-card', {
    staticClass: "mx-1 mt-4",
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin'])
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.mdiMinusThick))]), _vm._v("발행정보 "), _c('v-spacer'), _vm.order.status == '주문완료' ? _c('v-btn', {
    staticClass: "blue--text mr-2",
    attrs: {
      "small": "",
      "color": "white",
      "dark": ""
    },
    on: {
      "click": function ($event) {
        return _vm.batch(_vm.order);
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.mdiWalletGiftcard))]), _vm._v("전체 발행요청")], 1) : _vm._e(), _vm.order.cno && !_vm.order.refundedAt && !_vm.issues.find(function (issue) {
    return issue.refundedAt;
  }) ? _c('v-btn', {
    staticClass: "red--text",
    attrs: {
      "small": "",
      "color": "white",
      "dark": ""
    },
    on: {
      "click": function ($event) {
        return _vm.refund({
          order: _vm.order
        });
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.mdiCashRefund))]), _vm._v("전체 캐시환불")], 1) : _vm._e()], 1), _c('v-divider'), _c('v-data-table', {
    staticClass: "mx-1",
    attrs: {
      "items": _vm.issues,
      "headers": _vm.issuesHeaders
    },
    scopedSlots: _vm._u([{
      key: "item.no",
      fn: function (_ref9) {
        var item = _ref9.item;
        return [_vm._v(" " + _vm._s(_vm.issues.indexOf(item) + 1) + " ")];
      }
    }, {
      key: "item.giftcard",
      fn: function (_ref0) {
        var item = _ref0.item;
        return [item.giftcard ? _c('v-row', {
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "md": "auto"
          }
        }, [item.giftcard.thumb ? _c('v-img', {
          attrs: {
            "src": item.giftcard.thumb,
            "max-width": "96",
            "max-height": "56"
          }
        }) : _c('v-responsive', {
          attrs: {
            "width": "96",
            "height": "56"
          }
        }, [_c('v-row', {
          staticClass: "fill-height ma-0 grey lighten-3",
          attrs: {
            "align": "center",
            "justify": "center"
          }
        }, [_c('v-icon', [_vm._v("mdi-image")])], 1)], 1)], 1), _c('v-col', [_c('div', {
          staticClass: "text-start"
        }, [_vm._v("[" + _vm._s(item.platform) + "]")]), _c('div', {
          staticClass: "text-start"
        }, [_vm._v(_vm._s(item.giftcard.name))])])], 1) : _vm._e()];
      }
    }, {
      key: "item.sender",
      fn: function (_ref1) {
        var item = _ref1.item;
        return [_c('div', [_vm._v(_vm._s(item.sender.name) + " [" + _vm._s(item.sender.id) + "]")]), _c('div', [_vm._v(_vm._s(item.sender.phone.phoneNumberFormat()))]), _c('div', [_vm._v(_vm._s(item.sender.email))])];
      }
    }, {
      key: "item.faceamt",
      fn: function (_ref10) {
        var _item$faceamt2, _item$faceamt2$format;
        var item = _ref10.item;
        return [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$faceamt2 = item.faceamt) === null || _item$faceamt2 === void 0 ? void 0 : (_item$faceamt2$format = _item$faceamt2.format) === null || _item$faceamt2$format === void 0 ? void 0 : _item$faceamt2$format.call(_item$faceamt2)) + " ")];
      }
    }, {
      key: "item.quantity",
      fn: function (_ref11) {
        var _item$quantity2, _item$quantity2$forma;
        var item = _ref11.item;
        return [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$quantity2 = item.quantity) === null || _item$quantity2 === void 0 ? void 0 : (_item$quantity2$forma = _item$quantity2.format) === null || _item$quantity2$forma === void 0 ? void 0 : _item$quantity2$forma.call(_item$quantity2)) + " ")];
      }
    }, {
      key: "item.salesAmount",
      fn: function (_ref12) {
        var _item$salesAmount2, _item$salesAmount2$fo;
        var item = _ref12.item;
        return [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$salesAmount2 = item.salesAmount) === null || _item$salesAmount2 === void 0 ? void 0 : (_item$salesAmount2$fo = _item$salesAmount2.format) === null || _item$salesAmount2$fo === void 0 ? void 0 : _item$salesAmount2$fo.call(_item$salesAmount2)) + " ")];
      }
    }, {
      key: "item.mode",
      fn: function (_ref13) {
        var item = _ref13.item;
        return [item.mode == 'mobile' ? _c('span', [_vm._v("모바일")]) : _vm._e(), item.mode == 'paper' ? _c('span', [_vm._v("지류")]) : _vm._e()];
      }
    }, {
      key: "item.orderedAt",
      fn: function (_ref14) {
        var item = _ref14.item;
        return [_vm._v(" " + _vm._s(_vm.$dayjs(item.orderedAt).format("YYYY-MM-DD HH:mm:ss")) + " ")];
      }
    }, {
      key: "item.cancel",
      fn: function (_ref15) {
        var item = _ref15.item;
        return [item.status == '발권완료' ? _c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "small": "",
            "color": "white",
            "dark": ""
          },
          on: {
            "click": function ($event) {
              return _vm.cancel({
                issue: item
              });
            }
          }
        }, [_c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "small": ""
          }
        }, [_vm._v(_vm._s(_vm.mdiCloseCircleOutline))]), _vm._v("발권취소")], 1) : _vm._e()];
      }
    }, {
      key: "item.refund",
      fn: function (_ref16) {
        var item = _ref16.item;
        return [item.cno && !item.refundedAt && _vm.order.status != '취소완료' ? _c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "small": "",
            "color": "white",
            "dark": ""
          },
          on: {
            "click": function ($event) {
              return _vm.refund({
                issue: item
              });
            }
          }
        }, [_c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "small": ""
          }
        }, [_vm._v(_vm._s(_vm.mdiCashRefund))]), _vm._v("캐시환불")], 1) : _vm._e()];
      }
    }, {
      key: "item.resend",
      fn: function (_ref17) {
        var item = _ref17.item;
        return [item.status == '발권완료' && item.platform == 'chlifes' ? _c('v-btn', {
          staticClass: "blue--text",
          attrs: {
            "small": "",
            "color": "white",
            "dark": ""
          },
          on: {
            "click": function ($event) {
              return _vm.resend({
                issue: item
              });
            }
          }
        }, [_c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-message")]), _vm._v("재발행")], 1) : _vm._e()];
      }
    }, {
      key: "item.note",
      fn: function (_ref18) {
        var item = _ref18.item;
        return [_c('div', {
          staticClass: "text-end"
        }, [_c('p', {
          staticClass: "d-inline-block"
        }, [_vm._v(_vm._s(item.note))]), _c('v-icon', {
          staticClass: "d-inline-block ml-2",
          attrs: {
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.note(item);
            }
          }
        }, [_vm._v("mdi-pencil")])], 1)];
      }
    }], null, false, 3113134182)
  })], 1) : _vm._e(), _vm.order.mode == 'paper' ? _c('v-card', {
    staticClass: "mx-1 mt-4",
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin'])
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.mdiMinusThick))]), _vm._v("발행정보 ")], 1), _c('v-divider'), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.couriers,
      "label": "배송업체",
      "placeholder": " ",
      "hide-edtails": ""
    },
    model: {
      value: _vm.order.courier,
      callback: function ($$v) {
        _vm.$set(_vm.order, "courier", $$v);
      },
      expression: "order.courier"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "운송장번호",
      "placeholder": " ",
      "hide-edtails": ""
    },
    model: {
      value: _vm.order.invoiceNumber,
      callback: function ($$v) {
        _vm.$set(_vm.order, "invoiceNumber", $$v);
      },
      expression: "order.invoiceNumber"
    }
  })], 1), _c('v-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('v-text-field', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "label": "캐시승인번호",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.order.cno,
      callback: function ($$v) {
        _vm.$set(_vm.order, "cno", $$v);
      },
      expression: "order.cno"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm.order.cno && !_vm.order.refundedAt ? _c('v-btn', {
    staticClass: "red--text",
    attrs: {
      "small": "",
      "color": "white",
      "dark": ""
    },
    on: {
      "click": function ($event) {
        return _vm.refund({
          order: _vm.order
        });
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.mdiCashRefund))]), _vm._v("캐시환불")], 1) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e(), _c('v-row', {
    staticClass: "my-6"
  }, [_c('v-spacer'), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1), _c('v-spacer')], 1), _c('note-dialog', {
    ref: "noteDialog"
  })], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }